module.exports = __webpack_public_path__ + "static/media/Trainicon03@3x.648cd6b2.png";